import React, { Component } from 'react'
import { toast } from 'react-toastify';

export class ToastMessage extends Component {
  
    //TOAST MESSAGE SKELETON
    static show = (type, message) => {
        toast[type](message, {
            toastId: message.trim(),
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
        });
    }

}

export default ToastMessage